import styled from "styled-components";

const Content = styled.div`
  flex: 1;
  max-width: 600px;
  margin: auto;
`;

export default Content;
